"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var safelyParseJSON = function safelyParseJSON(json) {
  var parsed;
  // value is already JSON
  if ((0, _typeof2["default"])(json) === 'object') {
    return json;
  }
  try {
    parsed = JSON.parse(json);
  } catch (_e) {
    parsed = undefined;
  }
  return parsed;
};
module.exports = safelyParseJSON;